export default "__VITE_ASSET__X3$ZHCuO__"